var LocalWorkModule = /** @class */ (function () {
    function LocalWorkModule(source) {
        this.exportName = 'default';
        this.work = source;
    }
    LocalWorkModule.prototype.get = function () {
        return this.work;
    };
    LocalWorkModule.prototype.toString = function () {
        return "function(){\n      return {\n        default: " + this.work + "\n      }\n    }";
    };
    return LocalWorkModule;
}());
export default LocalWorkModule;
